/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import ModalFollowupsMyHistory from '../modal_followups_my_history';
import { Container } from './styles';

interface ListItensFollowupsProps {
  followups: any;
}

const ListItensFollowups = (props: ListItensFollowupsProps) => {
  const { followups } = props;
  const [showModal, setShowModal] = useState<boolean>(false);
  const [licitacao, setLicitacao] = useState<object | null>(null);

  useEffect(() => {
    licitacao !== null && setShowModal(true);
  }, [licitacao]);

  return (
    <Container>
      <div className="table-responsive" style={{ maxHeight: '400px' }}>
        <table className="table table-bordered">
          <thead className="thead-light">
            <tr>
              <th scope="col">N.º CNL</th>
              <th scope="col">Edital</th>
              <th scope="col">Órgão</th>
              <th scope="col">Cidade/Estado</th>
            </tr>
          </thead>
          <tbody>
            {followups?.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center border-0 pb-0">
                  <div className="alert alert-secondary m-0" role="alert">
                    <p className="mb-0">Não foram encontrados resultados para este filtro.</p>
                  </div>
                </td>
              </tr>
            )}
            {followups?.map((followup: any) => (
              <tr>
                <td>
                  <button
                    className="btn btn-link p-0"
                    type="button"
                    onClick={() => setLicitacao(followup)}
                  >
                    {followup?.followups?.id}
                  </button>
                </td>
                <td>{followup?.followups?.edital}</td>
                <td title={followup?.followups?.orgao?.nome}>{followup?.followups?.orgao?.nome}</td>
                <td>
                  {followup?.followups?.orgao?.cidade}/{followups[0]?.followups?.orgao?.estado}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {showModal && (
          <ModalFollowupsMyHistory
            showModal={showModal}
            setShowModal={setShowModal}
            followups={licitacao}
          />
        )}
      </div>
    </Container>
  );
};

export default ListItensFollowups;
